import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link as RouterLink } from "react-router-dom";

import { userActions, alertActions, utilityActions } from "../_actions";
import { getEnvironment } from "../_helpers";

import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";
import Link from "@mui/material/Link";
import Grid from "@mui/material/Grid";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import Typography from "@mui/material/Typography";
import makeStyles from '@mui/styles/makeStyles';
import Container from "@mui/material/Container";

import SnackbarContent from "@mui/material/SnackbarContent";
import ErrorIcon from "@mui/icons-material/Error";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";

import PageWithAppDrawer3 from "../_components/main/PageWithAppDrawer3";
import useOnlineStatus from "../_hooks/useOnlineStatus";
import { CircularProgress } from "@mui/material";
import useCustomerDNS from "../_hooks/useCustomerDNS";

import logoDvs from "../_assets/dvslogo_web_new_cropped.png";
import logoSvetna from "../_assets/svetna-logo.png";


export function LoginPage(props) {
  const classes = useLoginPageStyles();
  const dispatch = useDispatch();
  const isOnline = useOnlineStatus();
  const customerName = useCustomerDNS();

  const alert = useSelector((state) => state.alert);

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  useEffect(() => {
    dispatch(userActions.logout());
    dispatch(utilityActions.clearUtility("client_open_vehicles"));
    getEnvironment("reset");
  }, [dispatch]);

  useEffect(() => {
    return () => {
      dispatch(alertActions.clear());
    };
  }, []);

  const handleClearAlert = () => {
    const { dispatch } = this.props;
    dispatch(alertActions.clear());
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (username && password) {
      let options = {};
      options.customerName = customerName;
      if (customerName === 'svetna'){
        options.route = '/svetna/vehicledashboard';
      }
      dispatch(userActions.login(username, password, options ));
    }
  };

  return (
    <PageWithAppDrawer3
      pageTitle={"Login"}
      showSideBar={false}
      showHomeLinks={true}
    >
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <div className={classes.paper}>
          <img
            src={customerName === "svetna" ? logoSvetna : logoDvs}
            alt="logo"
            style={{width: '100%'}}
          />
          <Avatar className={classes.avatar}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography component="h1" variant="h5">
            Sign in {customerName.toUpperCase()}
          </Typography>

          <form className={classes.form} noValidate onSubmit={handleSubmit}>
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              id="username"
              label="Email Address"
              name="username"
              type="email"
              autoComplete="email"
              autoFocus
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              name="password"
              label="Password"
              type="password"
              id="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            {alert.message && (
              <SnackbarContent
                style={{ backgroundColor: "red" }}
                aria-describedby="client-snackbar"
                message={
                  <span
                    id="client-snackbar"
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    <ErrorIcon />
                    {alert.message}
                  </span>
                }
                action={[
                  <IconButton
                    key="close"
                    aria-label="close"
                    color="inherit"
                    onClick={handleClearAlert}
                    size="large">
                    <CloseIcon />
                  </IconButton>,
                ]}
              />
            )}

            <Button
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
              disabled={!isOnline}
              className={classes.submit}
            >
              {isOnline ? (
                `Sign In`
              ) : (
                <>
                  <CircularProgress
                    color="secondary"
                    size={16}
                    style={{ marginRight: 10 }}
                  />
                  Network Unavailable
                </>
              )}
            </Button>
            <Grid container>
              <Grid item xs={12}>
                <Link
                  component={RouterLink}
                  to={"/forgot-password"}
                  variant="button"
                >
                  Forgot Password?
                </Link>
              </Grid>
              <Grid item xs={12} style={{ marginTop: 20 }}>
                <Link component={RouterLink} to={"/register"} variant="button">
                  Register for an account
                </Link>
              </Grid>
            </Grid>
          </form>
        </div>
      </Container>
    </PageWithAppDrawer3>
  );
}

const useLoginPageStyles = makeStyles((theme) => ({
  "@global": {
    body: {
      backgroundColor: theme.palette.common.white,
    },
  },
  paper: {
    marginTop: theme.spacing(8),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));

export { LoginPage as default };
